module.exports = __webpack_public_path__ + "static/img/tjd3.444ca7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/tjd3.png
// module id = BirV
// module chunks = 0